const moment = require('moment');
const BigNumber = require('bignumber.js');

/***
 * 时间需要先获取服务器端的时间，然后在进行处理
 * 
 * 
 * ****/

const MAX_DIGITS_IN_UNSIGNED_256_INT = 78;
export function AddDayTimes(num) {
	return moment().add(num, 'days').unix();
}
export function AddmintTimes(num) {
	return moment().add(num, 'minutes').unix();
}
export function getNow() {
	return moment().unix();
}


export function generatePseudoRandomSalt() {
	const randomNumber = BigNumber.random(MAX_DIGITS_IN_UNSIGNED_256_INT);
	const factor = new BigNumber(10).pow(MAX_DIGITS_IN_UNSIGNED_256_INT - 1);
	const salt = randomNumber.times(factor).toFixed(0) ;
	return salt;
}